module.exports = __webpack_public_path__ + "img/Chat Icon.a02fe63f.svg";